const getRowCountSummary = (summaryText: string, rowCount: number): string => {
  return summaryText.replace("{{rowCount}}", `${rowCount}`).replace(/\d+/g, `${rowCount}`)
}

export const updateRowCountInToolbar = (grid: TGrid, summaryText: string) => {
  if (!grid) return

  const rowCount = grid.GetShownRows().length
  const toolbarSummaryText = getRowCountSummary(summaryText, rowCount)
  // @ts-expect-error
  grid.Toolbar.Summary = toolbarSummaryText
  grid.RefreshRow(grid.Toolbar)
}
